/**
 * Guia global de permissão de localização.
 * Qualquer captura de localização do sistema (vistoria, aceite, chat) chama
 * `showGeoPermissionGuide(falha)` e esta folha única orienta o usuário, em vez
 * de exibir um aviso de erro. Montado uma vez em App.
 *
 * RELEASE: 2026-10-22 v1.0.0 - Versão inicial.
 */
import { useEffect, useState } from 'react';
import { LocationPermissionSheet } from './LocationPermissionSheet';
import type { GeoFailure } from '@/lib/geoPermission';

const EVENTO = 'uaizy:geo-permission-guide';

/** Abre o guia global para a falha informada. */
export function showGeoPermissionGuide(failure: GeoFailure) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<GeoFailure>(EVENTO, { detail: failure }));
}

export function GlobalLocationPermissionGuide() {
  const [failure, setFailure] = useState<GeoFailure | null>(null);
  useEffect(() => {
    const ouvir = (e: Event) => setFailure((e as CustomEvent<GeoFailure>).detail);
    window.addEventListener(EVENTO, ouvir);
    return () => window.removeEventListener(EVENTO, ouvir);
  }, []);
  // "Tentar novamente" fecha o guia; o usuário repete a ação que pediu a localização.
  return <LocationPermissionSheet open={!!failure} state={failure ?? 'denied'} reason=""
    onRequest={() => setFailure(null)} onClose={() => setFailure(null)} />;
}
